import { IHotelContentResponse } from './interfaces/hotel-content.interfaces';
import { ApiService } from '../shared/services/api-service/api.service';

/**
 * @ignore
 */
declare const TCCommonService;

class HotelContent {
    async getHotelContent(hotelCode: number, languageCode: string) {
        const cacheKey = 'be_' + TCCommonService.ConfigService.getPlatformType() + '_wc_hotel_content_' +
            hotelCode + '_' + languageCode?.toLowerCase();
        const hotelContentFromCache = TCCommonService.BrowserStorageService.getBrowserStorage({ key: cacheKey });
        if (hotelContentFromCache) {
            return hotelContentFromCache;
        }
        try {
            const hotelContentApiResponse: Response = await ApiService.callHotelContentApi(hotelCode, languageCode);
            const hotelContentObject: IHotelContentResponse = await hotelContentApiResponse.json();
            TCCommonService.BrowserStorageService.setBrowserStorage({ key: cacheKey, value: hotelContentObject });
            return hotelContentObject;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const HotelContentService = new HotelContent();
